<template>
  <div>
    <!--
    <img  
      :alt="page"
      src="https://fmvoley.com/wp-content/uploads/2017/10/Cabecera3.png" >
    -->
    <!--
    <v-layout class="mb-1 mr-2 powered">
      <v-spacer/> 
      <span class="pr-1">Powered by</span>
      <a :href="$t('site.fullUrl')">{{ $t('site.name') }}</a>
    </v-layout>
    -->
    <template v-if="isLoading">
      <Loading :elevation="0" />
    </template>
    <template v-else-if="hasDbError">
      <Error v-for="(error, key) in dbErrors" v-if="error" :key="key" error="error" />
    </template>
    <template v-else>
      <MatchCard
        :current-user="currentUser"
        :club="club"
        :match="match"
        :sport="sport"
        :admin-mode="isClubAdmin"
        :editor-mode="isClubEditor"
        :viewer-mode="isClubViewer"
        :logged-mode="isLoggedUser"
        :display-sets="true"
        :hidde-details="true"
        :display-stats="true"
        :display-charts="true"
        :display-comments="true"
        :hide-menu="true"
        :hide-info="true"
        :hide-match-menu="true"
        :show-powered-by="true"
        :elevation="0"
        @onUpdate="onUpdateMatch"
        @onSendEvent="onSendEvent"
        @onToogleBlockMatch="onToogleBlockMatch"
        @onRemoveLastEvent="onRemoveLastEvent"
      />
    </template>
    <!--
    <v-layout class="my-2 mr-2 powered">
      <v-spacer/> 
      <span class="pr-1">Powered by</span>
      <a :href="$t('site.fullUrl')">{{ $t('site.name') }}</a>
    </v-layout>
    -->
  </div>
</template>

<script>
import _ from 'lodash'
import ClubsLib from '@/lib/data/clubs'
import MatchesLib from '@/lib/data/matches'
import SportHelper from '@/lib/SportHelper'
import MatchCard from '@/components/Dashboard/Views/Club/Views/WeekMatches/Views/Match/Templates/MatchCard'
import Loading from '@/components/UIComponents/Loading/Loading'
import Error from '@/components/UIComponents/Error/Error'
const debug = require('debug')('OD::Match')

export default {
  name: 'Match',
  components: { MatchCard, Loading, Error },
  props: {
    page: {
      type: String,
      required: true,
    },
    clubId: {
      type: String,
      required: true,
    },
    year: {
      type: String,
      required: true,
    },
    week: {
      type: String,
      required: true,
    },
    matchId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      club: {},
      match: {},
      loadings: {
        club: true,
        match: true,
      },
      dbErrors: {
        club: null,
        match: null,
      },
    }
  },
  computed: {
    currentUser() {
      return null
    },
    isLoggedUser() {
      return false
    },
    isClubAdmin() {
      return false
    },
    isClubEditor() {
      return false
    },
    isClubViewer() {
      return false
    },
    isLoading() {
      return _.values(this.loadings).filter(loading => loading).length > 0
    },
    hasDbError() {
      return _.values(this.dbErrors).filter(error => error && error !== '').length > 0
    },
    sport() {
      if (this.match && this.match.sport) {
        return SportHelper.getSportConfiguration(this.match.sport)
      }
      return SportHelper.getSportConfiguration(this.club.sport)
    },
  },
  watch: {
    clubId() {
      this.bind()
    },
    year() {
      this.bind()
    },
    week() {
      this.bind()
    },
    matchId() {
      this.bind()
    },
    club() {},
  },
  mounted() {
    this.bind()
  },
  beforeDestroy() {},
  methods: {
    bind() {
      ClubsLib.bindItem(this, { clubId: this.clubId })
      MatchesLib.bindItem(this, {
        clubId: this.clubId,
        year: this.year,
        week: this.week,
        matchId: this.matchId,
      })
    },
    onUpdateMatch(newItem, item) {
      debug('onUpdateMatch', newItem, item)
    },
    onSendEvent(data) {
      debug('onSendEvent', data)
    },
    onRemoveLastEvent(data) {
      debug('onRemoveLastEvent', data)
    },
    onToogleBlockMatch(data) {
      debug('onToogleBlockMatch', data)
    },
  },
}
</script>

<style lang="scss">
.powered {
  color: grey;
  a {
    text-decoration: none;
  }
}
</style>
